export const parseDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'N/A';
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC',
        }).format(date);
    } catch (error) {
        console.error('Error parsing date:', error);
        return 'N/A';
    }
};

export const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    
    try {
        const birthDate = new Date(dob);
        if (isNaN(birthDate.getTime())) return 'N/A';
        
        const today = new Date();
        
        // Use UTC dates for consistency with parseDate
        const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
        const birthUTC = new Date(Date.UTC(birthDate.getUTCFullYear(), birthDate.getUTCMonth(), birthDate.getUTCDate()));
        
        let age = todayUTC.getUTCFullYear() - birthUTC.getUTCFullYear();
        const monthDiff = todayUTC.getUTCMonth() - birthUTC.getUTCMonth();
        const dayDiff = todayUTC.getUTCDate() - birthUTC.getUTCDate();
        
        // If birthday hasn't occurred yet this year, subtract 1
        // Check month first, then day if months are equal
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }
        
        return age;
    } catch (error) {
        console.error('Error calculating age:', error);
        return 'N/A';
    }
}
